import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { TRUSTPILOT_URL } from '~/const/3rd';
export default {
  name: 'TrustPilot',
  mounted: function mounted() {
    var _this = this;

    this.asyncScript(TRUSTPILOT_URL).then(function () {}).catch(function (err) {
      _this.$logger.error("TRUSTPILOT_URL FAILED ".concat(err));
    });
  }
};